import React from "react";
import { Link } from "react-router-dom";
import { FiHeart, FiArrowRight } from "react-icons/fi";
import Card from "../Components/Card";
import properties from "../data/properties";
import { useApp } from "../context/AppContext";

export default function Favorites() {
  const { favorites, user } = useApp();
  const favoriteProperties = properties.filter((p) => favorites.includes(p.id));

  if (!user) {
    return (
      <div className="page-wrapper" style={{ marginTop: "62px" }}>
        <div className="container py-5">
          <div className="empty-state">
            <div className="empty-icon">🔒</div>
            <h3>Please Log In</h3>
            <p>You need to be logged in to view your favorite properties.</p>
            <Link to="/login" className="btn btn-primary rounded-pill px-4">
              Log In
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper" style={{ marginTop: "62px" }}>
      <div className="page-header" style={{ padding: "3rem 0 2rem" }}>
        <div className="container position-relative">
          <h1 className="mb-1" style={{ fontSize: "2rem" }}>
            <FiHeart className="me-2" /> My Favorites
          </h1>
          <p className="mb-0">
            {favoriteProperties.length} saved {favoriteProperties.length === 1 ? "property" : "properties"}
          </p>
        </div>
      </div>

      <div className="container py-4">
        {favoriteProperties.length > 0 ? (
          <div className="row g-4">
            {favoriteProperties.map((property) => (
              <div className="col-sm-6 col-lg-3" key={property.id}>
                <Card property={property} />
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">💔</div>
            <h3>No Favorites Yet</h3>
            <p>
              Start browsing properties and click the heart icon to save your
              favorites here.
            </p>
            <Link to="/properties" className="btn btn-primary rounded-pill px-4">
              Browse Properties <FiArrowRight className="ms-1" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
